import { useEffect } from "react";

interface OutsideAuthenticatedProps {
  children: React.ReactNode;
}
const OutsideAuthenticated: React.FC<OutsideAuthenticatedProps> = ({ children }) => {
  useEffect(() => {
    // 浏览器检测函数
    const detectBrowser = () => {
      const { userAgent } = navigator;
      let fullVersion = '';
      let isSupportedBrowser = false;

      // 检测 Edge (Chromium 内核)
      if (userAgent.indexOf("Edg") !== -1) {
        fullVersion = userAgent.substring(userAgent.indexOf("Edg") + 4);
        isSupportedBrowser = true;
      }
      // 检测 Chrome
      else if (userAgent.indexOf("Chrome") !== -1) {
        fullVersion = userAgent.substring(userAgent.indexOf("Chrome") + 7);
        isSupportedBrowser = true;
      }
      // 检测 IE 11
      else if ((userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1) && 
               (userAgent.indexOf("rv:11") !== -1 || userAgent.indexOf("MSIE 11") !== -1)) {
        fullVersion = "11";
        isSupportedBrowser = true;
      }
      // 其他浏览器
      else {
        fullVersion = "未知";
        isSupportedBrowser = false;
      }

      // 提取版本号
      if (fullVersion !== "未知") {
        const spaceIndex = fullVersion.indexOf(' ');
        if (spaceIndex !== -1) {
          fullVersion = fullVersion.substring(0, spaceIndex);
        }
        const semicolonIndex = fullVersion.indexOf(';');
        if (semicolonIndex !== -1) {
          fullVersion = fullVersion.substring(0, semicolonIndex);
        }
      }
      if (!isSupportedBrowser) {
        window.location.href = `${window.location.origin}/home?ref=${encodeURIComponent(window.location.href)}`;
      }
    };

    detectBrowser();
  }, []);
  return <div>{children}</div>;
};

export default OutsideAuthenticated;
